import { create } from "zustand";
import { pushRecent, type RecentItem } from "./recent";

const KALIT = "skud.recent";

/**
 * ⚠️ `localStorage` HAR DOIM `try/catch` ichida. Brauzer sayt
 * ma'lumotlarini bloklaganda `localStorage` ga MUROJAAT QILISHNING
 * O'ZI `SecurityError` tashlaydi — o'qish emas, ta'rifga tegish.
 * Qorovulsiz butun yon panel oq ekranga aylanardi.
 *
 * ⚠️ `crypto.randomUUID` va boshqa secure-context API'lari BU YERDA
 * ISHLATILMAYDI — staging TLS'siz LAN IP'da ishlaydi
 * (`secure-context.test.ts` qorovuli). `localStorage` secure context
 * talab qilmaydi.
 *
 * ⚠️ Ro'yxat SERVERGA yozilmaydi: u qulaylik, audit izi emas.
 *
 * Eksport qilingan — testda buzuq saqlangan qiymat qorovulini
 * to'g'ridan-to'g'ri tekshirish uchun (`useRecentlyViewed.test.ts`).
 */
export function read(): RecentItem[] {
	try {
		const xom = window.localStorage.getItem(KALIT);
		const parsed: unknown = xom ? JSON.parse(xom) : [];

		if (!Array.isArray(parsed)) {
			return [];
		}

		return parsed.filter(
			(entry): entry is RecentItem =>
				typeof entry === "object" &&
				entry !== null &&
				typeof (entry as RecentItem).path === "string" &&
				typeof (entry as RecentItem).label === "string"
		);
	} catch {
		return [];
	}
}

function write(items: RecentItem[]): void {
	try {
		window.localStorage.setItem(KALIT, JSON.stringify(items));
	} catch {
		// Saqlash imkoni yo'q — ro'yxat shu sessiyada yashaydi.
	}
}

interface RecentState {
	items: RecentItem[];
	remember: (item: RecentItem) => void;
	clear: () => void;
}

/**
 * ⚠️ Holat Zustand'da, komponent ichida `useState` da EMAS. `MainLayout`
 * DOIMIY layout marshruti — sessiya boshida BIR MARTA mount bo'ladi va
 * klient tomon navigatsiyada QAYTA mount bo'lmaydi. `LeadDetailPage` yoki
 * `TaskDetailPage` `remember()` chaqirganda, agar holat komponent ichida
 * bo'lsa, bu FAQAT o'sha sahifaning o'z nusxasini yangilardi — allaqachon
 * mount bo'lgan `MainLayout` bundan umuman xabar topmasdi va yon panel
 * to'liq sahifa qayta yuklanmaguncha bo'sh qolardi. Bitta umumiy do'kon
 * barcha iste'molchilarni bitta ro'yxatga obuna qiladi.
 *
 * `read()` modul yuklanishida BIR MARTA chaqiriladi (ilgari `useEffect`
 * ichida edi) — bu xavfsiz: u allaqachon `try/catch` bilan o'ralgan, va
 * `window` yo'q holatda (masalan SSR) tashlanadigan `ReferenceError` ham
 * shu bir xil blok tomonidan ushlanadi.
 */
export const useRecentStore = create<RecentState>((set, get) => ({
	items: read(),
	remember: (item) => {
		const keyingi = pushRecent(get().items, item);
		write(keyingi);
		set({ items: keyingi });
	},
	clear: () => {
		removeStored();
		set({ items: [] });
	},
}));

function removeStored(): void {
	try {
		window.localStorage.removeItem(KALIT);
	} catch {
		// Saqlash imkoni yo'q bo'lsa, o'chirishga ham urinishning ma'nosi yo'q.
	}
}

/**
 * Do'konni va `localStorage` kalitini tozalaydi.
 *
 * ⚠️ Bank kompyuteri ko'p xodim orasida bo'lishiladi: chiqishdan keyin
 * keyingi foydalanuvchi oldingisining «Yaqinda ko'rilgan» ro'yxatini
 * (lid va topshiriq nomlari) bosiladigan havola sifatida ko'rmasligi
 * kerak. Shuning uchun `useLogout` bu funksiyani auth do'koni
 * tozalangan joyda chaqiradi.
 */
export function clearRecent(): void {
	useRecentStore.getState().clear();
}

export function useRecentlyViewed(): {
	items: RecentItem[];
	remember: (item: RecentItem) => void;
} {
	const items = useRecentStore((state) => state.items);
	const remember = useRecentStore((state) => state.remember);

	return { items, remember };
}
